import { TrashIcon } from '@shared/assets/icons';
import { UnstyledButton } from '@shared/ui/unstyled-button';
import styles from './ClientMenuCell.module.scss';

interface ClientMenuCellProps {
  onDeleteClient: () => void;
}

export const ClientMenuCell = ({ onDeleteClient }: ClientMenuCellProps) => {
  return (
    <UnstyledButton onClick={onDeleteClient} className={styles.deleteButton}>
      <TrashIcon size="16" color="currentColor" />
    </UnstyledButton>
  );
};
